import { Controller } from "@hotwired/stimulus"

// A textarea that grows with what you type.
//
// Rides the .grow-wrap trick already in the stylesheet: the wrapper is a
// one-cell grid whose ::after mirrors the text and sets the row height, and the
// textarea is laid over it. The browser does the measuring during layout, so
// there is no scrollHeight read on every keystroke — no forced reflow, and no
// one-frame jump as a line wraps. Past the wrapper's max-height the textarea
// scrolls instead of growing.
//
// The composer's own ResizeObserver (activity_stream) is watching the form, so
// the timeline's bottom padding and the ask-user tray follow this on their own.
export default class extends Controller {
  static targets = ["field"]

  connect() {
    this.sync()
  }

  // Also called from a `reset` action: a form the browser resets keeps the old
  // mirrored text otherwise, leaving the box tall around an empty field.
  sync() {
    const field = this.field()
    if (!field) return

    this.element.dataset.replicatedValue = field.value
  }

  // Deferred: on `reset` the field still holds its old value when the event
  // fires, so measuring now would mirror the text that is about to go.
  syncAfterReset() {
    requestAnimationFrame(() => this.sync())
  }

  field() {
    return this.hasFieldTarget ? this.fieldTarget : this.element.querySelector("textarea")
  }
}
